import { h, Component } from 'preact';
import Store from 'store/store';
import * as actions from 'store/actions';
import s from 'components/shared/theaters/datesScroller.sss';
import ScrollBox from 'components/shared/scrollBox/scrollBox';
import DatesScrollerDate from 'components/shared/theaters/datesScrollerDate';
import pure from 'utils/pure';
import { accessNested } from 'utils/utils';
import { smoothScrollTo } from 'utils/smoothScroll';


export default @pure class DatesScroller extends Component {

	constructor(props) {
		super(props);
		this.keyDown = this.keyDown.bind(this);
	}

	componentDidUpdate(prevProps) {
		if (prevProps.selectedDate !== this.props.selectedDate) {
			const ds = this.$dayScroller.base;
			const elem = ds.children[this.props.stDates.indexOf(this.props.selectedDate) + 1];
			smoothScrollTo(ds, elem, 200, {
				direction: 'hor',
				relativeTo: 'view',
				offsetStart: 50,
				offsetEnd: 50
			});
		}
	}

	doScroll(dir) {
		const ds = this.$dayScroller;
		if (!ds || !ds.addForce) return;
		ds.addForce(dir * ds.base.clientWidth / 20);
	}

	keyDown(e) {
		if (e.key === 'ArrowRight' || e.key === 'Right') {
			let currentDateIndex = this.props.stDates.indexOf(this.props.selectedDate);
			if (currentDateIndex !== -1 && currentDateIndex !== this.props.stDates.length - 1) {
				Store.emit(actions.SELECT_ST_DATE, this.props.stDates[currentDateIndex + 1]);
			}
		}
		if (e.key === 'ArrowLeft' || e.key === 'Left') {
			let currentDateIndex = this.props.stDates.indexOf(this.props.selectedDate);
			if (currentDateIndex > 0) {
				Store.emit(actions.SELECT_ST_DATE, this.props.stDates[currentDateIndex - 1]);
			}
		}
	}

	render(props) {
		const {
			appData,
			stDates,
			selectedDate,
			screeningsPerDate,
			favIconId,
			device,
		} = props;

		const style = {};
		const direction = accessNested(appData, 'styling.variables.text-direction');
		const positionProp = direction === 'rtl' ? 'right' : 'left';
		style[positionProp] = (3 * stDates.indexOf(selectedDate)) + 'rem';

		return (
			<div class={s.container} tabindex="0" onKeyDown={this.keyDown}>
				<ScrollBox
					key="daysScroller"
					direction="x"
					class={s.dates}
					scrollableLeftClass={s.showLeft}
					scrollableRightClass={s.showRight}
					ref={$ref => this.$dayScroller = $ref}
					device={device}
				>
					<div class={s.indicator} style={style}>
						{/* Placeholder date (to ensure correct width) */}
						<div class={s.date}>
							<div class={s.name}>Wed</div>
							<div class={s.month}>May</div>
							<div class={s.date}>88</div>
						</div>
					</div>
					{stDates.map((stDate, i) => (
						<DatesScrollerDate
							selected={selectedDate === stDate}
							stDate={stDate}
							screenings={screeningsPerDate[i]}
							favIconId={favIconId}
						/>
					))}
				</ScrollBox>
				<div class={s.scrollLeft} onClick={this.doScroll.bind(this, -1)} />
				<div class={s.scrollRight} onClick={this.doScroll.bind(this, 1)} />
			</div>
		);
	}

}
